import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsClienteContatoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/cliente-contato');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async getContatosCliente(queries = {}) {
    try {
      const data = await this.api.get('/cliente-contato/findByCliente', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/cliente-contato', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/cliente-contato', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Cliente');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/cliente-contato/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/cliente-contato/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Cliente');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.api.post('/cliente-contato/delete', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Cliente');
    }
  }
}
